import { getTokenInfo } from "./api";

/**
 * Admin or employee, from the permissions carried in the access token.
 *
 * "All" is the Admin role's permission; anything else — including an empty
 * list — is an employee. Fail-closed by design.
 *
 * Extracted from the app shell because the router needs the same answer to
 * decide which dashboard is home, and two copies of a rule like this drift
 * into one screen thinking you are an admin while another does not.
 */
export const isAdminUser = () =>
  (getTokenInfo()?.accessTokenData?.newEffectivePermissions || []).includes("All");

export const resolveUserRole = () => (isAdminUser() ? "admin" : "employee");

/**
 * May this person set the organisation up — legal entities, geofences, company
 * details?
 *
 * Not the same question as isAdminUser, which is why it is its own function.
 * The company onboarding checklist was shown to everybody: the effect that
 * opens it consults no role at all, so an employee was handed "Onboard your
 * company on PayLoom" and a Start button pointing at endpoints that would
 * refuse them. It reached them because GET /legal-unit answered 403, the app
 * read the empty result as "this company has no legal entity", and offered to
 * fix it.
 *
 * "All" is the admin role. ManageOrganizationDetails is the grant an org owner
 * gives an HR administrator so they can do this work without being made a full
 * admin; it gates the same routes on the server.
 */
export const canManageOrganization = () => {
  const permissions = getTokenInfo()?.accessTokenData?.newEffectivePermissions || [];
  return permissions.includes("All") || permissions.includes("ManageOrganizationDetails");
};
